import { gql } from '@apollo/client/core';

const getPresignedUrl = gql`query($key: String!, $folder: String, $makePublic: Boolean) {
   getPresignedUrl(key: $key, folder: $folder, makePublic: $makePublic)
}`;

export default getPresignedUrl;
